export default "__VITE_ASSET__D7qdaP5J__"